export default {
  // 页面标题
  'luckySpin.ticket.title': '参与券设置',
  'luckySpin.ticket.management': '参与券管理',

  // 表单字段
  'luckySpin.ticket.ticketId': '券ID',
  'luckySpin.ticket.ticketName': '券名称',
  'luckySpin.ticket.ticketDescription': '券描述',
  'luckySpin.ticket.activityName': '绑定活动',
  'luckySpin.ticket.selectActivity': '选择活动',
  'luckySpin.ticket.validityType': '有效期类型',
  'luckySpin.ticket.validitySetting': '有效期设置',
  'luckySpin.ticket.validityHours': '领取后有效时长',
  'luckySpin.ticket.validTimeRange': '有效时间段',
  'luckySpin.ticket.sort': '排序值',
  'luckySpin.ticket.status': '状态',
  'luckySpin.ticket.remark': '备注',
  'luckySpin.ticket.createTime': '创建时间',
  'luckySpin.ticket.createUser': '创建人',
  'luckySpin.ticket.updateTime': '修改时间',
  'luckySpin.ticket.updateUser': '修改人',

  // 有效期类型
  'luckySpin.ticket.validity.permanent': '永久有效',
  'luckySpin.ticket.validity.afterReceive': '领取后指定时间',
  'luckySpin.ticket.validity.fixedTime': '固定时间段有效',

  // 状态
  'luckySpin.ticket.status.enabled': '启用',
  'luckySpin.ticket.status.disabled': '停用',

  // 按钮
  'luckySpin.ticket.button.add': '新增参与券',
  'luckySpin.ticket.button.edit': '编辑',
  'luckySpin.ticket.button.delete': '删除',
  'luckySpin.ticket.button.detail': '详情',
  'luckySpin.ticket.button.search': '查询',
  'luckySpin.ticket.button.reset': '重置',

  // 提示信息
  'luckySpin.ticket.tip.bindRule': '每张参与券只能绑定一个活动，一个活动可关联多个券。',
  'luckySpin.ticket.confirm.delete': '确定要删除该参与券吗？删除后不可恢复。',
  'luckySpin.ticket.message.createSuccess': '创建成功',
  'luckySpin.ticket.message.updateSuccess': '更新成功',
  'luckySpin.ticket.message.deleteSuccess': '删除成功',
  'luckySpin.ticket.message.operationFailed': '操作失败',
  'luckySpin.ticket.message.cannotDeleteWithUnusedTickets': '目前尚有会员参与券未使用，无法删除',

  // 表单验证
  'luckySpin.ticket.validate.ticketNameRequired': '请输入券名称',
  'luckySpin.ticket.validate.ticketNameMax': '券名称最多100个字符',
  'luckySpin.ticket.validate.activityRequired': '请选择活动',
  'luckySpin.ticket.validate.validityTypeRequired': '请选择有效期类型',
  'luckySpin.ticket.validate.validityHoursRequired': '请输入有效时长',
  'luckySpin.ticket.validate.validityHoursRange': '有效时长范围为1-720小时',
  'luckySpin.ticket.validate.validTimeRangeRequired': '请选择有效时间段',
  'luckySpin.ticket.validate.statusRequired': '请选择状态',
  'luckySpin.ticket.requiredVipLevel': 'VIP等级限制 ≥',
  'luckySpin.ticket.validate.requiredVipLevel': '请选择VIP等级限制（可选）',

  // 使用限制
  'luckySpin.ticket.usageRestrictionType': '使用限制类型',
  'luckySpin.ticket.restrictionAmount': '限制金额',
  'luckySpin.ticket.usageRestriction.none': '无限制',
  'luckySpin.ticket.usageRestriction.singleDeposit': '单笔存款金额',
  'luckySpin.ticket.usageRestriction.cumulativeDeposit': '累计存款金额',
  'luckySpin.ticket.usageRestriction.bettingTurnover': '投注流水',
  'luckySpin.ticket.usageRestriction.bettingTurnoverTip': '领取转盘券后开始计算',
  'luckySpin.ticket.validate.restrictionAmountRequired': '请输入限制金额',
  'luckySpin.ticket.validate.restrictionAmountMin': '金额必须大于0',
  'luckySpin.ticket.placeholder.usageRestrictionType': '请选择使用限制类型',
  'luckySpin.ticket.placeholder.restrictionAmount': '请输入金额',

  // 占位符
  'luckySpin.ticket.placeholder.ticketName': '请输入券名称',
  'luckySpin.ticket.placeholder.ticketDescription': '请输入券描述',
  'luckySpin.ticket.placeholder.selectActivity': '请选择活动',
  'luckySpin.ticket.placeholder.validityType': '请选择有效期类型',
  'luckySpin.ticket.placeholder.validityHours': '请输入小时数',
  'luckySpin.ticket.placeholder.startTime': '开始时间',
  'luckySpin.ticket.placeholder.endTime': '结束时间',
  'luckySpin.ticket.placeholder.sort': '请输入排序值，默认0',
  'luckySpin.ticket.placeholder.status': '请选择状态',
  'luckySpin.ticket.placeholder.remark': '请输入备注',

  // 弹窗标题
  'luckySpin.ticket.modal.addTitle': '新增参与券',
  'luckySpin.ticket.modal.editTitle': '编辑参与券',
  'luckySpin.ticket.modal.detailTitle': '参与券详情',

  // 整页表单
  'luckySpin.ticket.form.title.add': '新增参与券',
  'luckySpin.ticket.form.title.edit': '编辑参与券',
  'luckySpin.ticket.form.basicSettings': '基本设置',
  'luckySpin.ticket.form.multiLanguageSettings': '多语言设置（外部显示）',
  'luckySpin.ticket.form.ticketNameInternal': '参与券名称（内部使用）',
  'luckySpin.ticket.form.ticketNameExternal': '券名称（外部显示）',
  'luckySpin.ticket.form.ticketDescriptionInternal': '券描述',
  'luckySpin.ticket.form.ticketDescriptionExternal': '券描述（外部显示）',
  'luckySpin.ticket.form.bindActivity': '绑定活动',
  'luckySpin.ticket.form.selectActivity': '请选择大转盘活动',
  'luckySpin.ticket.form.language': '语言',
  'luckySpin.ticket.form.selectLanguage': '请选择语言',
  'luckySpin.ticket.form.save': '保存',
  'luckySpin.ticket.form.back': '返回',
  'luckySpin.ticket.form.saving': '保存中...',

  // 大转盘活动模板
  'luckySpin.template.title': '转盘设置',
  'luckySpin.template.prizeConfig': '奖品配置',
  'luckySpin.template.commonParams': '公共参数',

  // 奖项类型
  'luckySpin.template.prizeType': '奖项类型',
  'luckySpin.template.prizeType.cash': '现金类',
  'luckySpin.template.prizeType.point': '积分类',
  'luckySpin.template.prizeType.physical': '实物类',
  'luckySpin.template.prizeType.retry': '再来一次',
  'luckySpin.template.prizeType.noPrize': '未中奖',

  // 奖品字段
  'luckySpin.template.coinCode': '币种',
  'luckySpin.template.cashAmount': '金额',
  'luckySpin.template.flowMultiple': '流水倍数',
  'luckySpin.template.pointAmount': '积分数量',
  'luckySpin.template.prizeTitle': '奖品标题（内部使用）',
  'luckySpin.template.prizeConfigButton': '配置多语言名称',
  'luckySpin.template.prizeConfigured': '✓ 已配置多语言',
  'luckySpin.template.prizeLimit': '上限',
  'luckySpin.template.probability': '概率（%）',
  'luckySpin.template.operation': '操作',

  // 公共参数
  'luckySpin.template.visibleEntry': '可见入口',
  'luckySpin.template.ticketOnlyVisible': '仅有次数可见大转盘入口',
  'luckySpin.template.appOnly': '仅APP可用',
  'luckySpin.template.drawLimit': '抽奖限制',
  'luckySpin.template.requirePhoneVerified': '仅手机认证用户可抽奖',
  'luckySpin.template.cooldownSeconds': '冷却时间（秒）',

  // 提示信息
  'luckySpin.template.prizesCountHint': '转盘固定8个奖品（对应8个扇区）',
  'luckySpin.template.totalProbability': '概率总和',
  'luckySpin.template.probabilityError': '当前概率总和为 {value}%，需调整至100%',
  'luckySpin.template.rules': '规则说明',
  'luckySpin.template.rule0': '转盘固定8个奖品',
  'luckySpin.template.rule1': '概率支持4位小数',
  'luckySpin.template.rule2': '概率总和必须=100%',
  'luckySpin.template.rule3': '上限=-1表示不限制',
  'luckySpin.template.rule4': '至少需要一个奖品',

  // 验证消息
  'luckySpin.template.validate.prizeType': '请选择奖项类型',
  'luckySpin.template.validate.coinCode': '请选择币种',
  'luckySpin.template.validate.cashAmount': '请输入金额',
  'luckySpin.template.validate.cashAmountNegative': '金额不能为负数',
  'luckySpin.template.validate.flowMultiple': '请输入流水倍数',
  'luckySpin.template.validate.flowMultipleMin': '流水倍数必须≥1',
  'luckySpin.template.validate.pointAmount': '请输入积分数量',
  'luckySpin.template.validate.pointAmountNegative': '积分数量不能为负数',
  'luckySpin.template.validate.pointAmountInteger': '积分必须为整数',
  'luckySpin.template.validate.prizeTitle': '请输入奖品标题',
  'luckySpin.template.validate.prizeTitleMax': '最多100个字符',
  'luckySpin.template.validate.prizeLimit': '请输入上限',
  'luckySpin.template.validate.probability': '请输入概率',
  'luckySpin.template.validate.probabilityRange': '概率范围：0-100',
  'luckySpin.template.validate.cooldownSeconds': '请输入冷却时间',
  'luckySpin.template.validate.cooldownSecondsNegative': '冷却时间不能为负数',
  'luckySpin.template.validate.probabilitySum': '概率总和必须为100%',
  'luckySpin.template.validate.prizesCount': '转盘必须配置8个奖品',

  // 实物奖品多语言
  'luckySpin.template.physical.modalTitle': '配置实物奖品多语言',
  'luckySpin.template.physical.prizeTitle': '奖品标题',
  'luckySpin.template.physical.prizeImage': '奖品图片',
  'luckySpin.template.physical.langConfigured': '已配置 {count} 种语言',
  'luckySpin.template.physical.validate.prizeTitle': '请输入奖品标题',
  'luckySpin.template.physical.validate.prizeImage': '请上传奖品图片',
  'luckySpin.template.physical.saveSuccess': '多语言配置已保存',

  // 现金奖品多语言
  'luckySpin.template.cash.modalTitle': '配置现金奖品多语言',
  'luckySpin.template.cash.prizeImage': '奖品图片',
  'luckySpin.template.cash.prizeConfigButton': '配置多语言图片',
  'luckySpin.template.cash.langConfigured': '已配置 {count} 种语言',
  'luckySpin.template.cash.validate.prizeImage': '请上传奖品图片',
  'luckySpin.template.cash.saveSuccess': '多语言配置已保存',

  // 积分奖品多语言
  'luckySpin.template.points.modalTitle': '配置积分奖品多语言',
  'luckySpin.template.points.prizeImage': '奖品图片',
  'luckySpin.template.points.prizeConfigButton': '配置多语言图片',
  'luckySpin.template.points.langConfigured': '已配置 {count} 种语言',
  'luckySpin.template.points.validate.prizeImage': '请上传奖品图片',
  'luckySpin.template.points.saveSuccess': '多语言配置已保存',

  // 派发记录
  'luckySpin.grantLog.title': '参与券派发记录',
  'luckySpin.grantLog.ticketName': '参与券名称',
  'luckySpin.grantLog.grantSource': '发放渠道',
  'luckySpin.grantLog.grantType': '发放细则',
  'luckySpin.grantLog.userName': '会员账号',
  'luckySpin.grantLog.activityDataPkCode': '选择活动',
  'luckySpin.grantLog.selectActivity': '请选择活动',
  'luckySpin.grantLog.activityName': '转盘名称',
  'luckySpin.grantLog.status': '参与券状态',
  'luckySpin.grantLog.grantTime': '发放时间',
  'luckySpin.grantLog.type.label': '发放方式',
  'luckySpin.grantLog.type.placeholder': '请选择发放方式',
  'luckySpin.grantLog.search': '搜索',
  'luckySpin.grantLog.reset': '重置',
  'luckySpin.grantLog.export': '导出',
  'luckySpin.grantLog.exporting': '正在导出数据...',
  'luckySpin.grantLog.exportSuccess': '导出成功',
  'luckySpin.grantLog.exportFailed': '导出失败',

  // 发放渠道
  'luckySpin.grantLog.source.vipReward': 'VIP派发',
  'luckySpin.grantLog.source.batchGrant': '批量发放',
  'luckySpin.grantLog.source.systemReward': '系统奖励',
  'luckySpin.grantLog.source.manual': '人工发放',
  'luckySpin.grantLog.source.pointsMall': '积分商城',
  'luckySpin.grantLog.source.spinAgain': '再来一次',
  'luckySpin.grantLog.source.pointExchange': '积分兑换',
  'luckySpin.grantLog.source.actReward': '活动奖励',

  // 发放类型
  'luckySpin.grantLog.type.manual': '手动发放',
  'luckySpin.grantLog.type.vipUpgrade': 'VIP升级',
  'luckySpin.grantLog.type.activityReward': '活动奖励',
  'luckySpin.grantLog.type.system': '系统发放',

  // 券状态
  'luckySpin.grantLog.status.unused': '未使用',
  'luckySpin.grantLog.status.used': '已使用',
  'luckySpin.grantLog.status.expired': '已过期',
  'luckySpin.grantLog.status.cancelled': '已取消',

  // 抽奖使用记录
  'luckySpin.spinLog.title': '抽奖使用记录',
  'luckySpin.spinLog.userName': '会员账号',
  'luckySpin.spinLog.activityName': '转盘名称',
  'luckySpin.spinLog.ticketName': '参与券名称',
  'luckySpin.spinLog.spinTime': '中奖时间',
  'luckySpin.spinLog.prizeType': '中奖类型',
  'luckySpin.spinLog.prizeContent': '中奖内容',
  'luckySpin.spinLog.grantStatus': '发奖状态',
  'luckySpin.spinLog.grantTime': '发奖时间',
  'luckySpin.spinLog.search': '搜索',
  'luckySpin.spinLog.reset': '重置',
  'luckySpin.spinLog.export': '导出',
  'luckySpin.spinLog.exporting': '正在导出数据...',
  'luckySpin.spinLog.exportSuccess': '导出成功',
  'luckySpin.spinLog.exportFailed': '导出失败',

  // 中奖类型
  'luckySpin.spinLog.prize.cash': '现金',
  'luckySpin.spinLog.prize.points': '积分',
  'luckySpin.spinLog.prize.physical': '实物',
  'luckySpin.spinLog.prize.again': '再来一次',
  'luckySpin.spinLog.prize.none': '未中奖',

  // 发奖状态
  'luckySpin.spinLog.grant.pending': '待处理',
  'luckySpin.spinLog.grant.success': '成功',
  'luckySpin.spinLog.grant.failed': '失败',
};

